import React, { useRef, useEffect, useState } from 'react';
import './App.css';
import Footer from './Footer';

const images = [
  './images/kandy1.webp',
  './images/kandy2.webp',
  './images/kandy3.webp',
  './images/kandy4.webp',
  './images/kandy5.webp',
];

const TravelForm = () => {
  const carouselRef = useRef(null);
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (carouselRef.current) {
        const container = carouselRef.current;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;

        if (container.scrollLeft >= maxScrollLeft) {
          container.scrollLeft = 0;
        } else {
          container.scrollLeft += 260;
        }
      }
    }, 2000);

    return () => clearInterval(scrollInterval);
  }, []);

const content = {
  en: `Kandy is a cultural gem nestled in the heart of Sri Lanka’s Central Province. Known for the sacred Temple of the Tooth Relic and the spectacular Esala Perahera festival, this vibrant city offers a captivating blend of history, tradition, and natural beauty. Surrounded by lush forests and misty mountains, Kandy is a peaceful retreat rich in cultural heritage.

Top attractions and nearby places include:

• Temple of the Tooth Relic – A sacred Buddhist temple housing the relic of Buddha’s tooth.
• Kandy Lake – A serene lake perfect for an evening walk.
• Royal Botanical Gardens (Peradeniya) – Renowned for its orchids, palm collections, and medicinal plants.
• Pinnawala Elephant Orphanage – Observe rescued elephants in a riverine sanctuary.
• Bahirawakanda Vihara Buddha Statue – Offers panoramic views of the city.
• Kandy Market – A bustling bazaar with local crafts and produce.
• Udawattakele Forest Reserve – Great for birdwatching and nature walks.
• Kandyan Cultural Dance Show – Features fire-walking, drums, and traditional dances.
• Knuckles Mountain Range – Ideal for hiking and eco-tourism.

Whether you’re drawn by spirituality, nature, or cultural experiences, Kandy is a must-visit destination in Sri Lanka’s cultural triangle.`,

  zh: `

康提是位于斯里兰卡中央省的一颗文化明珠。它以佛牙寺和壮观的埃萨拉佩拉赫拉节而闻名，融合了历史、传统和自然美景，吸引了无数游客。康提四周被郁郁葱葱的森林和云雾缭绕的群山包围，是一个拥有丰富文化遗产的宁静之地。

热门景点及周边地区包括：

• 佛牙寺 – 供奉佛陀牙舍利的神圣佛教寺庙。
• 康提湖 – 宁静美丽，适合傍晚散步。
• 皇家植物园（佩拉德尼亚） – 拥有著名的兰花、棕榈和药用植物。
• 平纳瓦拉大象孤儿院 – 可近距离观察大象沐浴与活动。
• 巴希拉瓦坎达佛像 – 可俯瞰康提全景。
• 康提市场 – 热闹的手工艺品与农产品集市。
• 乌达瓦特凯勒森林保护区 – 适合观鸟与自然漫步。
• 康提传统舞蹈表演 – 展现火舞、鼓乐与传统服饰。
• 纳克尔斯山脉 – 适合徒步与生态旅游。

无论您是为了宗教信仰、自然风景还是文化体验来到康提，这里都是斯里兰卡文化三角区中的不可错过之地。`
};


  return (
    <div className="travel-form-container2">
      {/* Row 1 */}
      <div className="row row-one2">
        <div className="col image-col2">
          <img src="./images/kandy.webp"  className="travel-image2" />
          <img src="./images/kandy5.webp" className="travel-image2" />
        </div>

        <div className="col content-col2">
          <h2>Kandy</h2>

          {/* Language Toggle Button */}
          <div style={{ textAlign: 'right', marginBottom: '10px' }}>
            <button onClick={() => setLang(lang === 'en' ? 'zh' : 'en')} style={{ padding: '8px 16px', borderRadius: '6px', border: 'none', backgroundColor: '#967969', color: 'white', cursor: 'pointer' }}>
              {lang === 'en' ? '切换到中文' : 'Switch to English'}
            </button>
          </div>

          {/* Paragraph */}
          <p style={{ whiteSpace: 'pre-line' }}>{content[lang]}</p>
        </div>
      </div>

      {/* Row 2 - Auto Carousel */}
     <div className="carousel-container2">
       <div className="carousel-heading-column">
         <h2 className="carousel-heading">Explore Kandy</h2>
         <p className="carousel-subheading">A glimpse into the scenic beauty and cultural heritage</p>
       </div>

       <div className="carousel2" ref={carouselRef}>
         {images.map((imgSrc, index) => (
           <img key={index} src={imgSrc} className="carousel-image2" />
         ))}
       </div>
     </div>


      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TravelForm;
